import Logo from '@assets/images/logo-voluntarios.svg';

import { Link } from 'react-router-dom';
import { Section } from '@layouts/Section/Section';
import { Container } from '@layouts/Container/Container';
import {
  Dropdown,
  DropdownTrigger,
  DropdownContent,
  DropdownItem,
} from '@acb_devel/design-system';
import { Button } from '@acb_devel/design-system';
import { AngleDownIcon } from '@acb_devel/design-system';
import { LogoutIcon } from '@acb_devel/design-system';
import { PlusIcon } from '@acb_devel/design-system';
import { CreateEventModal } from '@components/assessors/organisms/CreateEventModal/CreateEventModal';
import { useModal } from '@acb_devel/design-system';
import { useUserContext } from '@contexts/UserContext';
import { useAuthContext } from '@contexts/AuthContext';
import { useEventsContext } from '@contexts/EventsContext';
import { ROLE_ADMIN } from '@services/users';

import styles from './Navbar.module.scss';

export function Navbar() {
  const { user } = useUserContext();
  const { logout } = useAuthContext();
  const { events } = useEventsContext();
  const { isOpen, openModal, closeModal } = useModal();

  return (
    <Section as="header">
      <nav className={styles.navbar}>
        <Container className={styles.navbar__container}>
          <Link to="/user/admin">
            <img
              src={Logo}
              alt="Logo Voluntarios acb"
              className={styles.navbar__logo}
            />
          </Link>
          <div className={styles.navbar__actions}>
            {user?.role === ROLE_ADMIN && (
              <>
                <Button variant="outline" color="accent" onClick={openModal}>
                  <PlusIcon /> Crear evento
                </Button>
                <CreateEventModal isOpen={isOpen} onClose={closeModal} />
              </>
            )}
            <Link to="/user/admin/events">
              <Button variant="solid" color="accent" upperCase={false}>
                Próximos eventos ({events.length})
              </Button>
            </Link>
            <Dropdown>
              <DropdownTrigger asChild>
                <Button color="accent" upperCase={false}>
                  {user?.acbidNickname && (
                    <>
                      ¡Hola {user?.acbidNickname}! <AngleDownIcon />
                    </>
                  )}
                  {!user?.acbidNickname && (
                    <>
                      ¡Hola! <AngleDownIcon />
                    </>
                  )}
                </Button>
              </DropdownTrigger>
              <DropdownContent>
                <DropdownItem onClick={logout}>
                  <LogoutIcon /> Cerrar sesión
                </DropdownItem>
              </DropdownContent>
            </Dropdown>
          </div>
        </Container>
      </nav>
    </Section>
  );
}
